/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef } from 'react'
import { useStaticQuery, graphql } from "gatsby";
import { v4 } from 'uuid';

// Images
import Icon from 'img/logo_pointing_left.inline.svg'

// Third Party
import Select from 'react-select'
import _ from 'lodash'
import styled, { css } from 'styled-components'

// Components
import Content from "components/Content";

// CSS
import "./GravityForm.scss";

// Utilities
import { chunkArray, calculateColumn } from "../../utils/index";

const GravityForm = ({ vacature, id, perColumn, kuufOnButton }) => {
  const { allGfForm: { edges: gravityData } } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(({ node }) => node.formId === id)[0];

  const [fields, setFields] = useState({});
  const [form, setForm] = useState(gfForm);
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let tempForm = form;

    // add submit button as a field
    if (tempForm.formFields.filter((item) => item.type === "submit").length === 0)  {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: "submit",
          text: tempForm.button.text
        }
      ];
    }

    if (perColumn) {
      tempForm = {
        ...tempForm,
        formFields: chunkArray(tempForm.formFields, perColumn)
      };
    }

    setForm({
      ...form,
      ...tempForm
    });
  }, [])

  async function handleOnSubmit(event) {
    event.preventDefault();

    if (status === 'processing') {
      return;
    }

    setStatus('processing');

    try {
      const formData = new FormData();

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value);
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData
      });

      const response = await request.json();
      if (response.is_valid === true) {
        setStatus('done');

        setMessage(response.confirmation_message);
      } else {
        setStatus('error');
        console.log(response);
      }
    } catch (error) {
      setStatus('error');
      console.error(error);
    }
  }

  function handleFieldChange(event) {
    // eslint-disable-next-line prefer-destructuring
    
    let {value} = event.target || event.value;

    if (event.target) {
      if (event.target.type === "checkbox") {
        value = event.target.checked ? event.target.value : "";
      }

      setFields({
        ...fields,
        [event.target.name]: value
      });
    } else {
      setFields({
        ...fields,
        [event.name]: event.value
      })
    }
  }

  if (status === "done") {
    return <Content className={vacature ? `form-submission-message-vacature` : `form-submission-message`} content={message} />
  }

  if (form.formFields) {
    return (
      <form method="post" className={`form form_${form.formId}`} onSubmit={handleOnSubmit}>
        {status === "processing" && (
          <Loading />
        )}
        <div className="row">
          {form.formFields && form.formFields.map((field, key) => {
            if (Array.isArray(field)) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={key} className={`col-lg-${calculateColumn(form.formFields.length)}`}>
                  {field.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <FormField kuufOnButton={kuufOnButton} vacature={vacature} key={index} field={item} fields={fields} onChange={handleFieldChange} />
                  ))}
                </div>
              )
            }

            return (
              <div className="col-lg-12">
                <FormField kuufOnButton={kuufOnButton} vacature={vacature} key={key} field={field} fields={fields} onChange={handleFieldChange} />
              </div>
            )
          })}
        </div>
      </form>
    )
  }

  console.error("No gravity forms found with id", id);
  return false;
}

const StyledTextField = styled.div`
  input {
    &::placeholder {
      padding: 4px 0 0 0;
      margin-bottom: 0;
    }
  }
`

const TextField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <StyledTextField className="form-group">
    {labelPlacement !== "hidden_label" && <label htmlFor={`input_${id}`}>{label}</label>}
    <input
      value={value}
      onChange={onChange}
      type="text"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextField>
)

const StyledEmailField = styled.div`
  input {
    &::placeholder {
      padding: 4px 0 0 0;
      margin-bottom: 0;
    }
  }
`

const EmailField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <StyledEmailField className="form-group">
    {labelPlacement !== "hidden_label" && <label htmlFor={`input_${id}`}>{label}</label>}
    <input
      value={value}
      onChange={onChange}
      type="email"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledEmailField>
)

const StyledPhoneField = styled.div`
  input {
    &::placeholder {
      padding: 4px 0 0 0;
      margin-bottom: 0;
    }
  }
`

const PhoneField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <StyledPhoneField className="form-group">
    {labelPlacement !== "hidden_label" && <label htmlFor={`input_${id}`}>{label}</label>}
    <input
      value={value}
      onChange={onChange}
      type="tel"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledPhoneField>
)

const StyledTextAreaField = styled.div`
  textarea {
    &::placeholder {
      padding: 4px 0 0 0;
      margin-bottom: 0;
    }
  }
`

const TextAreaField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <StyledTextAreaField className="form-group">
    {labelPlacement !== "hidden_label" && <label htmlFor={`input_${id}`}>{label}</label>}
    <textarea
      value={value}
      onChange={onChange}
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextAreaField>
)

const CheckboxField = ({ value, onChange, field: { id, type, cssClass, choices } }) => {
  const list = JSON.parse(choices);

  return (
    <div className="form-group">
      {list.map((checkbox, key) => (
        <div key={key} className="form-group__checkboxes">
          <input
            checked={value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <label htmlFor={`input_${id}_${key + 1}`} className="checkbox-content">{checkbox.text}</label>
        </div>
      ))}
    </div>
  )
}

const StyledIcon = styled(Icon)`
  position: absolute;
  left: 380px;
  bottom: 93px;
  height: 200px;
  width: 176px;

  @media screen and (max-width: 991px) {
    display: none;
  }
`

const SubmitButton = ({ vacature, field, kuufOnButton }) => (
  <div className={`${vacature ? `form-footer-vacature` : `form-footer`}`}>
    {kuufOnButton && <StyledIcon />}
    <button className={`button ${vacature ? `form-submit-vacature` : `form-submit`}`} type="submit">
      {field.text}
    </button>
  </div>
)



const SelectField = ({ field, onChange, value }) => {

  const options = []
  _.each(JSON.parse(field.choices), choice => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`
    })
  })

  console.log(options)

  const MySelect = props => (
    <Select
      {...props}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <div className="form-select">
      <MySelect 
        options={options}
        onChange={onChange}
        value={options.filter(option => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
        className="react-select-container"
      />
    </div>
  )
}

const Label = styled.label`
  display: block;
`

const StyledFileField = styled.div`
  ${Label} {
    width: 100%;
    border: solid 1px #DFDFDF;
    background-color: ${props => props.theme.color.secondary};
    height: 45px;
    border-radius: 5px;
    padding-left: 10px;
    margin-right: 10px;
    margin-bottom: 0;
    font-size: ${props => props.theme.font.size.sm};

    ${props => props.vacature && css`
      color: ${props.theme.color.light};
    `}
  }

  padding-bottom: 15px;

  .show-file {
    color: #FFFFFF !important;
  }

  button {
    height: 45px;
    width: 150px;
    border: solid 1px #DFDFDF;
    background-color: ${props => props.theme.color.main};
    border-radius: 5px;
    color: ${props => props.theme.color.secondary};
    text-overflow: ellipsis;
    font-size: ${props => props.theme.font.size.sm};
    transition: .25s;
    padding-top: 3px;
    white-space: nowrap;

    &:hover {
      transform: scale(1.05);
    }
  }

  input {
    display: none;
  }
`

const FileField = ({ vacature, value, onChange, field: { id, type, label, allowedExtensions, cssClass, placeholder } }) => {

  const inputRef = useRef(null)

  function handleChange(file) {
      onChange({
        target: {
          name: `input_${id}`,
          value: file
        }
      })
  }

  function handleFileUpload(e) {
    const { target: { files } } = e;

    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault();
    console.log(e);

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile());
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i]);
      }
    }
  }

  return (
    <StyledFileField vacature={vacature} className="d-flex form-upload" onDrop={handleFileDrop} onDragOver={e => e.preventDefault()}>
      <Label className="d-flex align-items-center" htmlFor={`input_${id}`}>
        {value ? value.name : label}
      </Label>
      <button
        type="button"
        onClick={() => {inputRef.current.click()}}
      >
        <p className="mb-0">Kies bestand</p>
      </button>
      <input
        ref={inputRef}
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
        name={`input_${id}`}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </StyledFileField>
  )
}

export const FormField = ({ vacature, field, fields, onChange, kuufOnButton }) => (
  <>
    {field.type === "text" && <TextField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "email" && <EmailField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "phone" && <PhoneField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "textarea" && <TextAreaField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "checkbox" && <CheckboxField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "select" && <SelectField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "fileupload" && <FileField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "submit" && <SubmitButton kuufOnButton={kuufOnButton} vacature={vacature} field={field} />}
  </>
)

export const Loading = () => (
  <div className="form-loading">
    <div className="form-loading-spinner">
      <div className="sk-chase">
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
        <div className="sk-chase-dot" />
      </div>
    </div>
  </div>
);

export default GravityForm;


